import { render, staticRenderFns } from "./CaseZJLY70.vue?vue&type=template&id=5f020884&scoped=true&"
import script from "./CaseZJLY70.vue?vue&type=script&lang=js&"
export * from "./CaseZJLY70.vue?vue&type=script&lang=js&"
import style0 from "./CaseZJLY70.vue?vue&type=style&index=0&id=5f020884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f020884",
  null
  
)

export default component.exports